import { useMemo, useState } from 'react';
import '../dashboard/css/core.css';
import '../dashboard/css/theme-default.css';
import '../dashboard/css/demo.css';
import '../dashboard/libs/perfect-scrollbar/perfect-scrollbar.css';
import '../dashboard/libs/apex-charts/apex-charts.css';
import '../dashboard/js/helpers';
import '../dashboard/js/config';
import '../dashboard/fonts/boxicons.css';
import '../dashboard/css/icons.css';
import '../dashboard/menuisidebar.css';
import '../dashboard/cssmaster/homemaster.css';
import avatar from '../dashboard/img/avatars/1.png';
import iconedogger from '../dashboard/img/icons/brands/logo_without_title.png';
import LocalStorage from '../../helpers/localstorage';
import { Link, useNavigate } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const menuItems = [
  { to: '/HomeMasterPage', icon: 'bx bx-home-circle', label: 'Visão geral' },
  {
    to: '/ConfigMasterDrivePage',
    icon: 'bx bx-car',
    label: 'Motoristas',
  },
  {
    to: '/ConfigMasterSubmasterPage',
    icon: 'bx bx-buildings',
    label: 'Empresas',
  },
  {
    to: '/ConfigMaterCategories',
    icon: 'bx bx-category-alt',
    label: 'Categorias',
  },
  {
    to: '/ConfigMasterCancelamento',
    icon: 'bx bx-x-circle',
    label: 'Cancelamentos',
  },
];

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();

  const userMeta = useMemo(
    () => ({
      name: 'Acesso master',
      role: 'Administrador',
    }),
    []
  );

  function toggleMenu() {
    setIsCollapsed((previous) => !previous);
  }

  function logout() {
    const storage = new LocalStorage();
    storage.removeAuthTokenMaster();
    navigate('/');
  }

  return (
    <div className="layout-wrapper layout-content-navbar centerLayout app-shell">
      <div className="layout-container">
        {!isCollapsed && (
          <aside
            id="layout-menu"
            className="layout-menu menu-vertical menu bg-menu-theme app-sidebar"
          >
            <div className="app-brand demo">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center gap-3">
                  <img src={iconedogger} width={46} height={46} alt="Logo master" />
                  <div>
                    <p className="mb-0 fw-bold">Track EPI</p>
                    <small className="text-muted">Painel master</small>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn btn-sm btn-light d-xl-none"
                  onClick={toggleMenu}
                  aria-label="Fechar menu"
                >
                  <i className="bx bx-chevron-left" />
                </button>
              </div>
            </div>

            <div className="menu-inner-shadow" />
            <ul className="menu-inner py-1">
              <li className="menu-item">
                {menuItems.map((item) => (
                  <Link key={item.to} to={item.to} className="menu-link menu-toggle">
                    <i className={`menu-icon tf-icons ${item.icon}`} />
                    <div>{item.label}</div>
                  </Link>
                ))}
              </li>
            </ul>
          </aside>
        )}

        <div className="layout-page app-page">
          <nav
            className="col-md-12 layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme app-topbar"
            id="layout-navbar"
          >
            <div className="layout-menu-toggle">
              <button
                type="button"
                className="nav-item nav-link px-0 me-xl-4 btn btn-link"
                onClick={toggleMenu}
                aria-label="Abrir menu"
              >
                <i className="bx bx-menu bx-sm" />
              </button>
            </div>

            <div
              className="navbar-nav-right d-flex align-items-center w-100"
              id="navbar-collapse"
            >
              <div className="navbar-nav align-items-center">
                <div className="nav-item d-flex align-items-center app-search">
                  <i className="bx bx-search fs-4 lh-0" />
                  <input
                    type="text"
                    className="form-control border-0 shadow-none"
                    placeholder="Pesquisar no painel"
                    aria-label="Pesquisar no painel"
                  />
                </div>
              </div>

              <ul className="navbar-nav flex-row align-items-center ms-auto">
                <li className="nav-item navbar-dropdown dropdown-user dropdown">
                  <button
                    type="button"
                    className="nav-link dropdown-toggle hide-arrow btn btn-link"
                    data-bs-toggle="dropdown"
                  >
                    <div className="avatar avatar-online">
                      <img
                        src={avatar}
                        alt="Avatar do usuário master"
                        className="w-px-40 h-auto rounded-circle"
                      />
                    </div>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <div className="dropdown-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar avatar-online">
                              <img
                                src={avatar}
                                alt="Avatar do usuário master"
                                className="w-px-40 h-auto rounded-circle"
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <span className="fw-semibold d-block">{userMeta.name}</span>
                            <small className="text-muted">{userMeta.role}</small>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="dropdown-divider" />
                    </li>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={logout}
                      >
                        <i className="bx bx-power-off me-2" />
                        <span>Sair</span>
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>

          <div className="content-wrapper app-content">
            <div className="d-flex justify-content-center align-items-center mt-3 ml-1 mr-1 centercard">
              <div className="col-md-12">{children}</div>
            </div>

            <footer className="content-footer footer bg-footer-theme app-footer">
              <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
                <div className="mb-2 mb-md-0">
                  © 2026 Track EPI. Painel administrativo central.
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
